<template>
  <div class="container">
    <div class="flex-sb margin-b20">
      <div>
        <el-button icon="el-icon-arrow-left" @click="toBack">返回</el-button>
      </div>
      <div>
        <el-button type="primary" @click="downStatement">下载对账单</el-button>
        <el-button
          type="danger"
          plain
          @click="handleRejectStatement"
          v-if="
            statementAccountStatus == 1 && !Number($route.query.isCancelOrNot)
          "
          >驳回对账单</el-button
        >
      </div>
    </div>
    <steps :stepData="stepData" :activeStep="activeStep" />
    <div id="printPage">
      <el-table :data="orderDetailData" class="margin-t">
        <el-table-column label="对账单基本信息">
          <el-table-column
            prop="statementAccountNo"
            label="对账单编号"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="statementAccountName"
            label="对账单名称"
            width="210"
          ></el-table-column>
          <el-table-column
            prop="supplierCompanyName"
            label="供应商名称"
          ></el-table-column>
          <el-table-column
            prop="resourceIncomeCompanyName"
            label="收款方"
          ></el-table-column>
          <el-table-column
            prop="supplierCompanyName"
            label="付款方"
          ></el-table-column>
          <el-table-column
                  prop="collectivePurchaseType"
                  width="120"
                  label="是否集采">
            <template slot-scope="scope">
              <div>{{  Number(scope.row.collectivePurchaseType) === 1 ? '集采' : '非集采'}}</div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>

      <el-table :data="orderDetailData" class="margin-t">
        <el-table-column label="对账信息">
          <el-table-column
            prop="statementAccountDate"
            label="对账周期"
            width="310"
          ></el-table-column>
          <el-table-column
            prop="statementAccountFee"
            label="对账单对账总金额（含税 元）"
          ></el-table-column>
          <el-table-column
            prop="serviceFee"
            label="总服务费（元）"
          ></el-table-column>
          <el-table-column prop="statementAccountStatusDesc" label="对账单状态">
            <template slot-scope="scope">
              <!--待供应商确认可撤回-->
              <div>
                <span
                  style="margin-right: 10px"
                  :class="{ 'is-red': scope.row.statementAccountStatus == 4 }"
                  >{{ scope.row.statementAccountStatusDesc }}</span
                >
                <span
                  v-if="
                    scope.row.statementAccountStatus == 5 ||
                    scope.row.statementAccountStatus == 3
                  "
                >
                  <el-image
                    v-if="isShowImg&&imgUrl"
                    style="width: 20px; height: 20px"
                    :src="imgUrl"
                    :preview-src-list="[imgUrl]"
                  >
                    ·
                  </el-image>
                </span>
                <!--                <span-->
                <!--                  class="view-pay"-->
                <!--                  v-if="scope.row.statementAccountStatus == 2"-->
                <!--                  @click="uploadPayPaper"-->
                <!--                  >上传支付凭证</span-->
                <!--                >-->
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>

      <div
        style="margin-top: 20px"
        v-if="isShowExport || shareContact.telephone"
      >
        <template v-if="isShowExport">
          <el-button type="primary" @click="batchHandle('1')"
            >批量确认</el-button
          >
          <el-button
            style="margin-right: 20px"
            type="primary"
            @click="batchHandle('2')"
            >批量驳回</el-button
          >
        </template>
        <span class="explain" v-if="shareContact.telephone">
          说明：若您对对账单有疑问，可拨打电话：{{ shareContact.contact }}
          {{ shareContact.telephone }}，邮箱：{{ shareContact.email }}进行咨询。
        </span>
      </div>

      <el-table
        :data="skuList"
        class="margin-t"
        @selection-change="handleSelectionChange"
        :span-method="arraySpanMethod"
      >
        <el-table-column label="订单商品明细">
          <el-table-column
            prop="orderNo"
            type="selection"
            width="55"
            :selectable="checkSelectable"
            v-if="isShowExport"
          ></el-table-column>
          <el-table-column
            prop="orderNo"
            label="订单编号"
            width="180"
          ></el-table-column>
          <el-table-column prop="isDoc" label="结算方式" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.isDoc ? '先货后款' : '先款后货' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="productCode"
            label="商品编号"
          ></el-table-column>
          <el-table-column
            prop="productName"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            prop="price"
            label="商品单价（含税 元）"
            width="140"
          ></el-table-column>
          <el-table-column
            prop="quantity"
            label="购买数量"
            width="70"
          ></el-table-column>
          <el-table-column
            prop="goodsUnitName"
            label="单位"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="subtotal"
            label="小计（含税 元）"
            width="110"
          ></el-table-column>
          <el-table-column prop="serviceFeeRate" label="服务费率" width="70">
            <template slot-scope="scope">
              <span>{{ scope.row.serviceFeeRate }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="serviceFee"
            label="服务费（元）"
            width="100"
          ></el-table-column>
          <el-table-column label="确认状态" width="80" prop="orderNo">
            <template slot-scope="scope">
              <div class="show-line" v-if="statementAccountStatus != 4">
                <el-button
                  type="primary"
                  @click="
                    supplierConfirm(
                      '1',
                      false,
                      scope.row.statementAccountDetailId,
                      scope.row.orderId
                    )
                  "
                  v-if="!scope.row.confirmStatus"
                  >确认</el-button
                >
                <el-button
                  type="danger"
                  style="margin-top: 10px"
                  @click="
                    handleReject(
                      '2',
                      false,
                      scope.row.statementAccountDetailId,
                      scope.row.orderId
                    )
                  "
                  v-if="!scope.row.confirmStatus"
                  >驳回</el-button
                >
                <el-button
                  type="text"
                  disabled
                  v-if="scope.row.confirmStatus == 1"
                  >已确认</el-button
                >
                <el-button
                  type="text"
                  style="color: #ef4c56"
                  disabled
                  v-if="scope.row.confirmStatus == 2 || scope.row.confirmStatus == 3"
                  >已驳回</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-table :data="confirmData" class="margin-t" border>
        <el-table-column
          prop="totalStatementAccountAmount"
          label="对账单对账总金额"
        ></el-table-column>
        <el-table-column prop="confirmFee" label="确认金额"></el-table-column>
        <el-table-column prop="rejectFee" label="驳回金额"></el-table-column>
        <el-table-column
          prop="totalServiceAmount"
          label="总服务费"
        ></el-table-column>
      </el-table>
    </div>
    <reject-dialog
      :visible="visible"
      @closeDialog="closeDialog"
      @submitPopupData="submitPopupData"
    />
    <confirm-dialog :visible="confirmVisible" @closeDialog="closeDialog" />
    <upload-dialog
      :visible="uploadVisible"
      @submitUploadData="submitUploadData"
      @closeDialog="closeDialog"
    />
  </div>
</template>

<script>
import api from '../../../api/order';
import rejectDialog from './rejectDialog';
import confirmDialog from './confirmDialog';
import uploadDialog from './uploadDialog';
import steps from './steps';

export default {
  components: { rejectDialog, confirmDialog, uploadDialog, steps },
  data() {
    return {
      needMergeArr: ['orderNo', 'confirmStatus'], // 有合并项的列
      rowMergeArrs: {}, // 包含需要一个或多个合并项信息的对象
      stepData: [
        {
          title: '创建',
          description: '平台创建对账单',
          handlePeo: '',
          creatTime: '',
        },
        {
          title: '供应商确认',
          description: '供应商确认对账单',
          handlePeo: '',
          creatTime: '',
        },
        {
          title: '支付',
          description: '供应商支付服务费',
          handlePeo: '',
          creatTime: '',
        },
        {
          title: '平台确认',
          description: '平台/境内公司确认支付状态',
          handlePeo: '',
          creatTime: '',
        },
        {
          title: '完成',
          description: '对账单对账完成',
          handlePeo: '',
          creatTime: '',
        },
      ],
      activeStep: 1,
      statementAccountStatus: '',
      orderDetailData: [],
      selectedResourceIdList: [],
      confirmData: [],
      startTime: '',
      endTime: '',
      skuList: [],
      selectData: [],
      rejectReason: '',
      visible: false,
      confirmVisible: false,
      uploadVisible: false,
      statementAccountId: '',
      supplierCompanyId: '',
      isShowExport: true,
      statementAccountDetailId: '',
      isShowImg: true,
      orderId: '',
      shareContact: {
        contact: '',
        telephone: '',
        email: '',
      },
    };
  },
  methods: {
    async queryShareContact(secondCompanyId) {
      const res = await api.queryShareContact({ secondCompanyId });
      if (res.code === '200' && res.data) {
        this.shareContact = res.data;
      }
    },
    toBack() {
      this.$router.back();
    },
    handleRejectStatement() {
      this.$confirm('确认要驳回该对账单吗？', '提示', {
        confirmButtonText: '确认驳回',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.rejectStatement();
      });
    },
    //驳回对账单
    rejectStatement() {
      let params = {
        statementAccountId: this.statementAccountId,
        supplierCompanyId: this.supplierCompanyId,
      };
      api.rejectStatement(params).then((res) => {
        if (res.success) {
          this.$message.success('对账单已驳回！');
          this.statementAccountDetail();
        }
      });
    },
    downStatement() {
      if (this.statementAccountStatus == 1) {
        this.isShowExport = false;
      }
      this.isShowImg = false;
      setTimeout(() => {
        this.getPdf('printPage');
      }, 100);
      if (this.statementAccountStatus == 1) {
        setTimeout(() => {
          this.isShowExport = true;
        }, 100);
      }
      setTimeout(() => {
        this.isShowImg = true;
      }, 100);
    },
    submitUploadData(params) {
      api
        .supplierPay({
          ...params,
          statementAccountId: this.statementAccountId,
          statementAccountNo: this.orderDetailData[0].statementAccountNo,
        })
        .then((res) => {
          if (res.code === '200') {
            this.$message.success('上传成功！');
            this.uploadVisible = false;
            this.statementAccountDetail();
          }
        });
    },
    uploadPayPaper() {
      this.uploadVisible = true;
    },
    //可以勾选的
    checkSelectable(row) {
      return row.confirmStatus !== 1 && row.confirmStatus !== 2 ? true : false;
    },
    handleSelectionChange(val) {
      this.selectData = val.map((item) => item.orderId);
      console.log(this.selectData);
    },
    batchHandle(flag) {
      if (this.selectData.length == 0) {
        return this.$message('请选择商品。');
      }
      if (flag == '1') {
        this.$confirm('确定要确认选中的订单吗？', '对账单确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.supplierConfirm(flag, 'true');
        });
      } else {
        this.visible = true;
        this.isBatch = true;
      }
    },
    handleReject(flag, isBatch, statementAccountDetailId, id) {
      this.visible = true;
      this.isBatch = false;
      this.orderId = id;
    },
    supplierConfirm(flag, isBatch, statementAccountDetailId, id) {
      let params = {
        statementAccountId: this.statementAccountId,
        isWholeStatementAccount: 0,
        // statementAccountDetailId: isBatch
        //   ? this.selectData
        //   : [statementAccountDetailId],
        confirmStatus: flag, //1 通过 2驳回
        statementAccountNo: this.orderDetailData[0].statementAccountNo,
        rejectReason: this.rejectReason,
        orderIdList: isBatch ? this.selectData : [id],
      };
      api.supplierConfirm(params).then((res) => {
        if (res.code === '200' && isBatch) {
          this.$message.success('批量操作完成！'); //单个的不用提示
        }
        this.statementAccountDetail();
        this.closeDialog();
      });
    },
    closeDialog() {
      this.visible = false;
      this.confirmVisible = false;
      this.uploadVisible = false;
    },
    submitPopupData(rejectReason) {
      this.rejectReason = rejectReason;
      this.supplierConfirm(
        '2',
        this.isBatch,
        this.statementAccountDetailId,
        this.orderId
      );
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // 没办法循环判断具体是那一列 所以就只好写了多个if
      if (column.property === 'orderNo')
        return this.mergeAction('orderNo', rowIndex, column);
      if (column.property === 'confirmStatus')
        return this.mergeAction('confirmStatus', rowIndex, column);

      // 如果一下子合并多个，那么就写多个判断， 如果只有一个就写一个判断
      /* if (column.property === "id")
        return this.mergeAction("id", rowIndex, column); */
    },

    mergeAction(val, rowIndex, colData) {
      let _row = this.rowMergeArrs[val].rowArr[rowIndex];
      let _col = _row > 0 ? 1 : 0;
      return [_row, _col];
    },

    rowMergeHandle(arr, data) {
      if (!Array.isArray(arr) && !arr.length) return false;
      if (!Array.isArray(data) && !data.length) return false;
      let needMerge = {};
      arr.forEach((i) => {
        needMerge[i] = {
          rowArr: [],
          rowMergeNum: 0,
        };
        data.forEach((item, index) => {
          // 表格首个数据单独处理
          if (index === 0) {
            needMerge[i].rowArr.push(1);
            needMerge[i].rowMergeNum = 0;
          } else {
            // 如果后一项与前一项相等，只用改变 rowArr 数组，不用管 rowMergeNum 数值
            if (item[i] === data[index - 1][i]) {
              // 后一项name与前一项name对比
              needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1; //此处是 rowMergeNum 属性存在的意义，就是为了定位要改变的数值
              needMerge[i].rowArr.push(0);
            }
            //如果后一项与前一项不相等，rowArr、rowMergeNum都改变
            else {
              needMerge[i].rowArr.push(1);
              needMerge[i].rowMergeNum = index;
            }
          }
        });
      });
      return needMerge;
    },
    //查看详情
    statementAccountDetail() {
      api
        .statementAccountDetail({
          statementAccountId: this.statementAccountId,
          supplierCompanyId: this.supplierCompanyId,
        })
        .then((res) => {
          if (res.code === '200') {
            this.queryShareContact(res.data.supplierCompanyId);
            this.skuList = res.data.productList;
            this.rowMergeArrs = this.rowMergeHandle(
              this.needMergeArr,
              this.skuList
            ); // 处理数据
            console.log(this.rowMergeArrs, 'this.rowMergeArrs');

            this.imgUrl = res.data.attachmentUrl;
            this.orderDetailData = [{ ...res.data }];
            this.statementAccountStatus = res.data.statementAccountStatus;
            if (this.statementAccountStatus == 1) {
              this.isShowExport = true;
            } else {
              this.isShowExport = false;
            }
            let params = {
              totalStatementAccountAmount: res.data.statementAccountFee,
              confirmFee: res.data.confirmFee,
              rejectFee: res.data.rejectFee,
              totalServiceAmount: res.data.serviceFee,
            };
            this.confirmData = [{ ...params }];

            if (res.data.statementAccountStatus == 4) {
              //撤回
              this.stepData = [
                {
                  title: '创建',
                  description: '平台创建对账单',
                  handlePeo: res.data.createTimeByName,
                  creatTime: res.data.createTime,
                },
                {
                  title: '撤回',
                  description: '平台撤回对账单',
                  handlePeo: res.data.cancelByName || '',
                  creatTime: res.data.cancelTime || '',
                },
              ];
            } else if (res.data.statementAccountStatus == 6) {
              //驳回
              this.stepData = [
                {
                  title: '创建',
                  description: '平台创建对账单',
                  handlePeo: res.data.createTimeByName,
                  creatTime: res.data.createTime,
                },
                {
                  title: '驳回',
                  description: '供应商驳回对账单',
                  handlePeo: res.data.cancelByName || '',
                  creatTime: res.data.cancelTime || '',
                },
              ];
            } else {
              this.stepData[0].handlePeo = res.data.createTimeByName || '';
              this.stepData[0].creatTime = res.data.createTime || '';
              this.stepData[1].handlePeo = res.data.supplierConfirmByName || '';
              this.stepData[1].creatTime = res.data.supplierConfirmTime || '';
              this.stepData[2].handlePeo = res.data.supplierPayByName || '';
              this.stepData[2].creatTime = res.data.supplierPayTime || '';
              this.stepData[3].handlePeo = res.data.platformConfirmByName || '';
              this.stepData[3].creatTime = res.data.platformConfirmTime || '';
              if (res.data.statementAccountStatus == 5) {
                this.stepData[4].handlePeo = '自动';
                this.stepData[4].creatTime = res.data.completeTime || '';
              }
              // switch (res.data.statementAccountStatus) {
              //   case 2:
              //     this.activeStep = 2;
              //     break;
              //   case 3:
              //     this.activeStep = 3;
              //     break;
              //   case 5:
              //     this.activeStep = 5;
              //     break;
              // }
              this.updateActiveStep(res.data.statementAccountStatus);
            }
            //待付款
            if (this.statementAccountStatus == 2) {
              let supperConfirmData = JSON.parse(
                localStorage.getItem('supperConfirmData')
              );
              if (
                supperConfirmData.statementAccountId ==
                  this.statementAccountId &&
                supperConfirmData.statementAccountStatus == 1
              ) {
                this.confirmVisible = true;
                let params = {
                  statementAccountId: this.statementAccountId,
                  statementAccountStatus: this.statementAccountStatus,
                };
                localStorage.setItem(
                  'supperConfirmData',
                  JSON.stringify(params)
                );
              }
            }
          }
        });
    },
    updateActiveStep(status) {
      switch (status) {
        case 2:
          this.activeStep = 2;
          break;
        case 3:
          this.activeStep = 3;
          break;
        case 5:
          this.activeStep = 5;
          break;
      }
    },
  },
  mounted() {
    (this.statementAccountId = this.$route.query.statementAccountId),
      (this.supplierCompanyId = this.$route.query.supplierCompanyId);
    this.statementAccountDetail();
  },
};
</script>

<style scoped lang="scss">
.margin-t {
  margin-top: 20px;
}
.is-red {
  color: #ef4c56;
}
.line {
  display: flex;
  justify-content: flex-end;
}
.flex-sb {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.show-line {
  display: flex;
  flex-direction: column;
  align-items: center;
  ::v-deep .el-button + .el-button {
    margin-left: 0;
  }
}

.view-pay {
  color: #2d8cf0;
  cursor: pointer;
  &:hover {
    border-bottom: 1px solid #2d8cf0;
  }
}
.explain {
  color: #2d8cf0;
}
</style>
